import React, { useState, useEffect } from 'react';

function MedicalForm({ onSubmit, onCancel, initialData = {} }) {
  const [formData, setFormData] = useState({
    allergies: '',
    medications: '',
    medical_conditions: '',
    emergency_contact_name: '',
    emergency_contact_phone: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        allergies: initialData.allergies || '',
        medications: initialData.medications || '',
        medical_conditions: initialData.medical_conditions || '',
        emergency_contact_name: initialData.emergency_contact_name || '',
        emergency_contact_phone: initialData.emergency_contact_phone || '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Allergies</label>
        <textarea name="allergies" value={formData.allergies} onChange={handleChange} />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Current Medications</label>
        <textarea name="medications" value={formData.medications} onChange={handleChange} />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Ongoing Medical Conditions</label>
        <textarea name="medical_conditions" value={formData.medical_conditions} onChange={handleChange} />
      </div>

      <div className="pt-4 border-t">
        <h3 className="text-lg font-semibold text-slate-700">Emergency Contact</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Contact Name</label>
              <input type="text" name="emergency_contact_name" value={formData.emergency_contact_name} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Contact Phone</label>
              <input type="text" name="emergency_contact_phone" value={formData.emergency_contact_phone} onChange={handleChange} />
            </div>
        </div>
      </div>
      
      <div className="flex justify-end gap-4 pt-4 mt-2 border-t border-slate-200">
        <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
        <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Medical Info</button>
      </div>
    </form>
  );
}

export default MedicalForm;